import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NewsletterReward, NewsletterService } from '../../../../shared/services/newsletter.service';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-newsletter-signup',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, TranslatePipe],
  templateUrl: './newsletter-signup.component.html',
  styleUrl: './newsletter-signup.component.scss',
})
export class NewsletterSignupComponent implements OnInit {
  private static nextInstanceId = 0;
  private readonly instanceId = ++NewsletterSignupComponent.nextInstanceId;

  @Input() compact = false;
  @Input() popup = false;
  @Output() subscribed = new EventEmitter<void>();

  private readonly formBuilder = inject(FormBuilder);
  readonly form = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
    consent: [false, Validators.requiredTrue],
    termsAgreement: [false, Validators.requiredTrue],
  });

  reward: NewsletterReward | null = null;
  isSubmitting = false;
  message = '';
  isError = false;

  constructor(private readonly newsletterService: NewsletterService) {}

  get emailId(): string {
    return `${this.compact ? 'footer' : 'marketplace'}-newsletter-email-${this.instanceId}`;
  }

  get titleId(): string {
    return `newsletter-title-${this.instanceId}`;
  }

  get emailErrorId(): string {
    return `${this.emailId}-error`;
  }

  ngOnInit(): void {
    this.newsletterService.getReward().subscribe({
      next: (reward) => (this.reward = reward),
      error: (error) => {
        console.error('Could not load newsletter reward details', error);
      },
    });
  }

  submit(): void {
    if (this.form.invalid || this.isSubmitting) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.message = '';
    this.newsletterService
      .subscribe(this.form.controls.email.value || '', this.form.controls.consent.value || false)
      .subscribe({
        next: (response) => {
          this.message = response.message;
          this.isError = false;
          this.form.reset({ email: '', consent: false, termsAgreement: false });
          this.isSubmitting = false;
          this.subscribed.emit();
        },
        error: (error) => {
          this.message =
            error?.error?.message ||
            'We could not complete your subscription. Please try again.';
          this.isError = true;
          this.isSubmitting = false;
        },
      });
  }
}
